export function formatFileSize(bytes: number) {
  if (bytes < 1024 * 1024) {
    return `${Math.max(1, Math.round(bytes / 1024))} KB`
  }

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export function isAcceptedDemoAudioFile(file: File) {
  const extension = file.name.split('.').pop()?.toLowerCase()
  return extension === 'mp3' || extension === 'wav' || extension === 'm4a' || extension === 'flac'
}
